import { type BasicCallhomeSite, type CallhomeAiTag, type SiteId } from '@solinkcorp/api-types';
import React, { createContext, useContext } from 'react';

export interface AiTag {
  id?: string;
  cloudId: string;
  resellerId: string;
  customerId: string;
  name: string;
}

export interface CallhomeClient {
  getAiTag(filter: { where: { customerId: string } }): Promise<CallhomeAiTag[]>;
  postAiTag(data: AiTag): Promise<AiTag>;
  getBasicSites(): Promise<BasicCallhomeSite[]>;
  getSite<T>(siteId: SiteId, params?: Record<string, unknown>): Promise<T>;
}

const CallhomeClientContext = createContext<CallhomeClient | null>(null);

export function useCallhomeClient(): CallhomeClient {
  const client = useContext(CallhomeClientContext);
  if (!client) {
    throw new Error('useCallhomeClient must be used within a CallhomeClientProvider');
  }
  return client;
}

export function CallhomeClientProvider({
  client,
  children,
}: {
  client: CallhomeClient;
  children: React.ReactNode;
}) {
  return <CallhomeClientContext.Provider value={client}>{children}</CallhomeClientContext.Provider>;
}
